const DEFAULT_STICKY_HEADER_MIN_HEIGHT_DESKTOP = 280;
const DEFAULT_STICKY_HEADER_MIN_HEIGHT_MOBILE = 240;

type OfferWithDisplayInfo = {
  displayName?: string | null;
  termsAndFeesLink?: string | null;
};

export type StickyHeaderCalculation = {
  stickyHeaderMinHeights: {
    desktop: number;
    mobile: number;
  };
  anyLargeOfferTitle: boolean;
  anyRatesAndFeesOffer: boolean;
};

const MAX_OFFER_TITLE_LENGTH_BEFORE_HEIGHT_INCREASE = 42;

export function calculateStickyHeaderHeights(
  offers: OfferWithDisplayInfo[],
): StickyHeaderCalculation {
  const anyLargeOfferTitle = offers.some(
    offer =>
      offer?.displayName &&
      offer.displayName.length > MAX_OFFER_TITLE_LENGTH_BEFORE_HEIGHT_INCREASE,
  );
  const anyRatesAndFeesOffer = offers.some(offer => offer?.termsAndFeesLink);

  let desktopHeight = DEFAULT_STICKY_HEADER_MIN_HEIGHT_DESKTOP;
  let mobileHeight = DEFAULT_STICKY_HEADER_MIN_HEIGHT_MOBILE;

  if (anyLargeOfferTitle) {
    desktopHeight += 20;
  }
  if (anyRatesAndFeesOffer) {
    desktopHeight += 20;
    mobileHeight += 20;
  }

  return {
    stickyHeaderMinHeights: {
      desktop: desktopHeight,
      mobile: mobileHeight,
    },
    anyLargeOfferTitle,
    anyRatesAndFeesOffer,
  };
}
